import PushesModeSwitch from './components/PushesModeSwitch/PushesModeSwitch';
import PushesView from './components/PushesView/PushesView';
import ScheduleView from './components/ScheduleView/ScheduleView';
import React, { useState } from 'react';
import style from './SoftwareTab.module.scss';

const SoftwareTab: React.FC = () => {
	const [pushesMode, setPushesMode] = useState<'pushes' | 'schedule'>('pushes');

	return (
		<div className={style.container}>
			<div className={style.modeSwitch}>
				<PushesModeSwitch pushesMode={pushesMode} setPushesMode={setPushesMode} />
			</div>
			<div>{pushesMode === 'pushes' ? <PushesView /> : <ScheduleView />}</div>
		</div>
	);
};

export default SoftwareTab;
